import type { ComputedRef } from 'vue'
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useKidStore } from './store'

interface KidDetailHeaderReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

/** General info is the kid page itself; the Changelog tab adds a crumb, and the open page's crumb is disabled. */
export const useKidDetailHeader = (): KidDetailHeaderReturn => {
  const route = useRoute()
  const kidStore = useKidStore()

  const config = computed<LinkBreadcrumbItem[]>(() => {
    const kid = kidStore.getKid

    const items: LinkBreadcrumbItem[] = [
      {
        id: 'customers',
        text: 'Customers',
        to: AppRoute.Customers,
        disabled: false,
      },
    ]

    if (!kid) return items

    const kidUrl = resolveUrl(AppRoute.KidsShow, { id: kid.id })
    const isChangelog = route.path === resolveUrl(AppRoute.KidsChangelog, { id: kid.id })

    items.push(
      {
        id: 'customer',
        text: `Customer / ${kid.customer_id}`,
        to: resolveUrl(AppRoute.CustomersShow, { id: kid.customer_id }),
        disabled: false,
      },
      {
        id: `kid-${kid.id}`,
        text: `Kids / ${kid.name}`,
        to: kidUrl,
        disabled: route.path === kidUrl,
      },
    )

    if (isChangelog) {
      items.push({
        id: 'kid-changelog',
        text: 'Changelog',
        to: null,
        disabled: true,
      })
    }

    return items
  })

  return {
    config,
  }
}
